import { useQuery } from 'react-apollo';

import { useAuthService } from '@/contexts/authService';
import { UserQueryPublicBasic } from '@services/gql/user';
import { User } from '@/types/user';

const useUser = (): { loading: boolean; user: User | undefined } => {
  const authService = useAuthService();
  const loggedInUserId = authService.getUserCookie();
  const query = UserQueryPublicBasic;
  const variables = {
    id: loggedInUserId,
  };
  const { data, loading } = useQuery(query, {
    variables,
    skip: !loggedInUserId,
  });
  return {
    loading,
    user: data?.profile,
  };
};

export default useUser;
